import { render, staticRenderFns } from "./BranchDetails.vue?vue&type=template&id=1572ea1e&"
import script from "./BranchDetails.vue?vue&type=script&lang=js&"
export * from "./BranchDetails.vue?vue&type=script&lang=js&"
import style0 from "./BranchDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1572ea1e')) {
      api.createRecord('1572ea1e', component.options)
    } else {
      api.reload('1572ea1e', component.options)
    }
    module.hot.accept("./BranchDetails.vue?vue&type=template&id=1572ea1e&", function () {
      api.rerender('1572ea1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modals/BranchDetails.vue"
export default component.exports